import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { Toaster } from "@/components/ui/sonner";
import { Layout } from "@/components/Layout";
import { ProtectedRoute } from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import AuthPage from "@/pages/AuthPage";
import AuthCallback from "@/pages/AuthCallback";
import Onboarding from "@/pages/Onboarding";
import Assessment from "@/pages/Assessment";
import Dashboard from "@/pages/Dashboard";
import Blueprint from "@/pages/Blueprint";
import Timeline from "@/pages/Timeline";
import Gardens from "@/pages/Gardens";
import Journal from "@/pages/Journal";
import Prayer from "@/pages/Prayer";
import Scripture from "@/pages/Scripture";
import Season from "@/pages/Season";
import Modules from "@/pages/Modules";
import Membership from "@/pages/Membership";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Tend from "@/pages/Tend";
import HowWeSpeak from "@/pages/HowWeSpeak";
import GrowthPatterns from "@/pages/GrowthPatterns";

const AppRouter = () => {
    const location = useLocation();
    // Detect OAuth session_id in URL fragment BEFORE running normal routing
    if (location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }
    return (
        <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/how-we-speak" element={<HowWeSpeak />} />
            <Route path="/login" element={<AuthPage mode="login" />} />
            <Route path="/signup" element={<AuthPage mode="signup" />} />
            <Route path="/auth/callback" element={<AuthCallback />} />

            <Route path="/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />
            <Route path="/assessment" element={<ProtectedRoute><Assessment /></ProtectedRoute>} />

            <Route path="/dashboard" element={<ProtectedRoute requireOnboarded><Layout><Dashboard /></Layout></ProtectedRoute>} />
            <Route path="/blueprint" element={<ProtectedRoute requireOnboarded><Layout><Blueprint /></Layout></ProtectedRoute>} />
            <Route path="/timeline" element={<ProtectedRoute requireOnboarded><Layout><Timeline /></Layout></ProtectedRoute>} />
            <Route path="/patterns" element={<ProtectedRoute requireOnboarded><Layout><GrowthPatterns /></Layout></ProtectedRoute>} />
            <Route path="/gardens" element={<ProtectedRoute requireOnboarded><Layout><Gardens /></Layout></ProtectedRoute>} />
            <Route path="/journal" element={<ProtectedRoute requireOnboarded><Layout><Journal /></Layout></ProtectedRoute>} />
            <Route path="/prayer" element={<ProtectedRoute requireOnboarded><Layout><Prayer /></Layout></ProtectedRoute>} />
            <Route path="/scripture" element={<ProtectedRoute requireOnboarded><Layout><Scripture /></Layout></ProtectedRoute>} />
            <Route path="/season" element={<ProtectedRoute requireOnboarded><Layout><Season /></Layout></ProtectedRoute>} />
            <Route path="/tend" element={<ProtectedRoute requireOnboarded><Layout><Tend /></Layout></ProtectedRoute>} />
            <Route path="/membership" element={<ProtectedRoute><Layout><Membership /></Layout></ProtectedRoute>} />
            <Route path="/payment/success" element={<ProtectedRoute><Layout><PaymentSuccess /></Layout></ProtectedRoute>} />
            <Route path="/payment/cancel" element={<ProtectedRoute><Layout><PaymentCancel /></Layout></ProtectedRoute>} />
            <Route path="/modules" element={<ProtectedRoute requireOnboarded><Layout><Modules /></Layout></ProtectedRoute>} />
        </Routes>
    );
};

export default function App() {
    return (
        <div className="App">
            <ThemeProvider>
                <BrowserRouter>
                    <AuthProvider>
                        <AppRouter />
                        <Toaster position="top-center" richColors />
                    </AuthProvider>
                </BrowserRouter>
            </ThemeProvider>
        </div>
    );
}
